module.exports = __webpack_public_path__ + "img/bm.1887dd7.svg";